import { render } from "./OrdersHome.vue?vue&type=template&id=455c0425&scoped=true"
import script from "./OrdersHome.vue?vue&type=script&lang=js"
export * from "./OrdersHome.vue?vue&type=script&lang=js"

import "./OrdersHome.vue?vue&type=style&index=0&id=455c0425&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455c0425"]])

export default __exports__